import React from "react";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";

const NotFound = () => {
  return (
    <Container>
      <Typography variant="h4">Page Not Found</Typography>
    </Container>
  );
};

export default NotFound;
